// licenseMakingStatistics 学员制证照数量

import React, {useEffect, useState} from "react";

import TimeSetting from './TimeSetting'
import {SchoolDropdown} from "./DropdownCondition/index";
import TrainingLine from './Charts/TrainingLine'
import {licenseMakingStatistics} from '@/service/chart'

import styles from './card.module.less'

function LicenseMakingStatistics(props) {
  const [chartData, setChartData] = useState([])
  const [orgId, setOrgId] = useState(null)
  const [dateType, setDateType] = useState(0)


  useEffect(() => {
    requestData()
  }, [ orgId, dateType])

  const requestData = () => {
    licenseMakingStatistics({
      orgId,
      dateType,
    }).then(res => {
      const data = res.data
      if(data.length) {
        const chargegArr = []
        const noChargeArr = []
        for(const item of data) {
          chargegArr.push({
            date: item.dateTime,
            name: '收费人数',
            count: item.chargeCount
          })

          noChargeArr.push({
            date: item.dateTime,
            name: '未收费人数',
            count: item.noChargeCount
          })
        }

        setChartData([...chargegArr, ...noChargeArr])
      }
    })
  }

  const selectedChangeHandler = (dateType) => {
    setDateType(dateType.id)
  }

  const timeSettingProps = {
    title: '日期范围',
    items: [{id: 0, name: '近7天', key: 0}, {id: 1, name: '近30天', key: 1}, {id: 2, name: '近半年', key: 2}],
    selectedChange: selectedChangeHandler
  }

  const schoolSelectedChange = (value) => {
    setOrgId(value)
  }

  const defs = [{
    dataKey: 'count',
    min: 0,
    type: 'linear',
    minTickInterval: 1,
    formatter(value) {
      return `${value} 人`;
    },
  }];

  return (
    <div className={styles.card}>
      <div className={styles.title}>学员制证照数量</div>
      <div className={styles.condItem}>
        <TimeSetting {...timeSettingProps} />
      </div>
      <div className={styles.condItem}>
        <SchoolDropdown dropdownChange={schoolSelectedChange} />
      </div>

      <TrainingLine data={chartData}  defs={defs} />
    </div>
  )

}

export default LicenseMakingStatistics
